// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	'use strict';

        var lastScrollTop = 0;
        var header = document.querySelector('header');
        var headerWrapper = document.querySelector('.site-header-wrapper');

        /**
         * Sets header hidden when needed.
         */
        function setHeader() {
            // Get current scrollTop
            var st = document.documentElement.scrollTop;

            
            if (st > lastScrollTop && st > 150) {
                // We're going down below breakpoint, hide header
                header.classList.add('hide');
            } else if (st < lastScrollTop) {
                // We're going up, show header
                header.classList.remove('hide');
            }

            if (st > 200) {
                header.classList.add('condensed');
                headerWrapper.classList.remove('py-3');
            } else {
                header.classList.remove('condensed');
                headerWrapper.classList.add('py-3');
            }

            if (header.classList.contains('condensed') == false && header.classList.contains('hide') == false) {
                header.classList.add('top');
            } else {
                header.classList.remove('top');
            }

            // Update lastScrollTop
            lastScrollTop = st;
        }

        window.addEventListener('resize', setHeader);
        window.addEventListener('scroll', setHeader);
} )();
